import Homepage from 'pages/Homepage.vue';
import FatalAccidentRoutes from 'pages/fatal-accident-claims/routes';
import LostYearsRoutes from 'pages/lost-years-claims/routes';
import ClaimsDashboardRoutes from 'pages/claims-dashboard/routes';
import MiniCalculatorsRoutes from 'pages/mini-calculators/routes';
import ResourcesAndToolsRoutes from 'pages/resources-and-tools/routes';
import PersonalInjuryRoutes from 'pages/personal-injury-claims/routes';
import ExecutiveDashboardRoutes from 'pages/executive-dashboard/routes';
import ReservingRoutes from 'pages/reserving/routes';
import MarketAnalysisRoutes from 'pages/market-analysis/routes';
import SupportRoutes from 'pages/support/routes';
import CompareRoutes from 'pages/compare/routes';
import DiscountRateComparison from 'pages/discount-rate-comparison/routes'
import FourOFour from 'pages/404/routes';
import FiveOThree from 'pages/503/routes';

export default [
    {
        name: 'homepage',
        path: '/',
        component: Homepage,
    },
].concat(
    ...[
        FatalAccidentRoutes,
        LostYearsRoutes,
        ClaimsDashboardRoutes,
        MiniCalculatorsRoutes,
        ResourcesAndToolsRoutes,
        PersonalInjuryRoutes,
        ExecutiveDashboardRoutes,
        ReservingRoutes,
        MarketAnalysisRoutes,
        SupportRoutes,
        CompareRoutes,
        DiscountRateComparison,
        FourOFour,
        FiveOThree
    ],
);


// WEBPACK FOOTER //
// ./src/pages/routes.js